import { getCookie } from "./cookies";

export const getGAClientId = (): string => getCookie("_ga")?.substring(6) ?? "";
